import { formatDisplayDateTime } from '../../../shared/utils/dateFormat';

const WEIGHT_FORMATTER = new Intl.NumberFormat('th-TH', {
  maximumFractionDigits: 2,
});

export function formatDate(value) {
  return formatDisplayDateTime(value, 'ไม่ระบุ');
}

export function parseWeightValue(value) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  if (typeof value !== 'string') {
    return 0;
  }

  const parsedValue = Number.parseFloat(value.replace(/,/g, ''));
  return Number.isFinite(parsedValue) ? parsedValue : 0;
}

export function formatWeight(value) {
  return `${WEIGHT_FORMATTER.format(value)} kg`;
}

export function readingLabel(reading) {
  if (!reading) {
    return 'ยังไม่มีการอ่าน';
  }

  return reading.readingValue || 'ไม่ระบุ';
}

export function formatScaleReadingValue(value) {
  const rawValue = typeof value === 'number'
    ? String(value)
    : String(value ?? '').trim();

  const numericParts = rawValue.match(/^([+-]?)(\d+)(\.\d+)?$/);
  if (!numericParts) {
    return rawValue;
  }

  const [, sign, integerPart, fractionPart = ''] = numericParts;
  const normalizedIntegerPart = integerPart.replace(/^0+(?=\d)/, '');

  return `${sign}${normalizedIntegerPart}${fractionPart}`;
}

export function scaleReadingLabel(reading) {
  if (!reading) {
    return 'ยังไม่มีการอ่าน';
  }

  return formatScaleReadingValue(reading.readingValue) || 'ไม่ระบุ';
}

export function formatReadingSource(readingSource) {
  if (readingSource === 'QrCalculated') {
    return 'คำนวณจาก QR';
  }

  if (readingSource === 'Manual') {
    return 'กรอกด้วยตนเอง';
  }

  return '';
}

export function statusClass(value) {
  return String(value ?? 'ไม่ระบุ').toLowerCase().replace(/\s+/g, '-');
}

export function formatRequestLoadStatus(status) {
  if (!status) {
    return 'Unknown';
  }

  return status === 'InProgress' ? 'In progress' : status;
}
